module.exports = __webpack_public_path__ + "static/media/image_placeholder.0a6e6a4e.jpg";